import { useEffect, useState } from "react";

// Render a "relative time" label (e.g. "5m ago", "3h ago"). The input
// `t` is an epoch-millisecond timestamp. Defensive: if `t` is missing,
// zero, non-finite, or negative, render "—" rather than the previous
// "20568d ago" (Date.now() - 0 is ~56 years in milliseconds).
export default function Rel({ t }: { t: number }) {
  const [, force] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => force((x) => x + 1), 15_000);
    return () => window.clearInterval(id);
  }, []);

  if (!t || !Number.isFinite(t) || t <= 0) {
    return <span className="rel">—</span>;
  }

  const d = Date.now() - t;
  const abs = new Date(t).toLocaleString("en-GB", { hour12: false });
  let label: string;
  if (d < 0) label = "in the future";
  else if (d < 60_000) label = `${Math.max(1, Math.floor(d / 1000))}s ago`;
  else if (d < 3_600_000) label = `${Math.floor(d / 60_000)}m ago`;
  else if (d < 86_400_000) label = `${Math.floor(d / 3_600_000)}h ago`;
  else label = `${Math.floor(d / 86_400_000)}d ago`;
  return (
    <span title={abs} className="rel">
      {label}
    </span>
  );
}
